
import React, { Component, Fragment } from 'react';
import { Button, message, DatePicker } from 'antd';
import CpSteps from '../../components/CpSteps';
import CpAddressModal from '../../components/CpAddressModal';
import CpLoading from '../../components/CpLoading';
import cpSelected from '../../assets/cp-selected.png';
import send from '../../util/request';
import { dateFormat } from '../../util/tool';
import cpLogoImg from '../../assets/cp-logo.png';
import { DownOutlined, UpOutlined, PlusOutlined } from '@ant-design/icons';
import moment from 'moment';
import { enquiryCreateOrder } from './api';
import './style.less';

const { localStorage } = window;

const stepConfig = {
  enquiryCart: [
    { name: '我的询价单', status: 2 },
    { name: '核对询价单信息', status: 1 },
    { name: '成功提交询价单', status: 0 }
  ],
  '2': [
    { name: '我的计划单', status: 2 },
    { name: '核对计划单信息', status: 1 },
    { name: '成功提交计划单', status: 0 }
  ],
  '3': [//cpm CPM销售订货清单
    { name: '我的订货单', status: 2 },
    { name: '核对订货单信息', status: 1 },
    { name: '成功提交订货单', status: 0 }
  ],
};

export default class EnquirySubmit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      shopList: [],
      addressList: [],
      currentAddress: {},
      otherAddressList: [],
      addressIsFold: true,
      currentSupplierId: 0,
      addressModalVisible: false,
      loading: true,
      submitLock: false,
      abroad_transport_type: undefined,
      domestic_transport_type: undefined,
      totalPrice: 0,
      expected_date: ''
    };

    this.record = {};
    const params = new URLSearchParams(this.props.location.search);
    this.type = params.get('type');
    this.addressId = +params.get('addressId');
    this.columns = [
      { key: 'product', name: '商品信息', align: 'left' },
      { key: 'sale_number', name: '数量', align: 'center' },
    ];
    this.columnsForPlan = [
      { key: 'product', name: '商品信息', align: 'left' },
      { key: 'norms_price', name: '单价', align: 'center', color: '#D60505' },
      { key: 'number', name: '数量', align: 'right', },
    ];
  }
  componentDidMount() {
    try {
      this.requestAddressList();
      this.requestProductList();
    } catch (error) {
      console.log("🚀 ~ file: SubmitOrder.js ~ line 62 ~ SubmitOrder ~ componentDidMount ~ error", error);
    } finally {
      this.setState({ loading: false });
    }
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  requestProductList = async () => {
    const dataStr = localStorage.getItem('orderData');
    const formatData = JSON.parse(dataStr);
    this.setState({ shopList: formatData, totalCount: formatData.length });
    // const { data: { data = {}, msg, code } } = await inventoryOrderConfirm({ order_data: formatData });
    // if (+code === 0) {
    //   const { order_data: shopList = [] } = data;
    //   let totalCount = 0, totalPrice = 0;
    //   for (const item of shopList) {
    //     const { sale_list = [] } = item;
    //     for (const sItem of sale_list) {
    //       const { number = 0, norms_price = 0 } = sItem;
    //       totalCount = accAdd(totalCount, number);
    //       totalPrice = accAdd(totalPrice, (number * norms_price || 0));
    //     }
    //   }
    //   this.setState({ shopList, totalCount, totalPrice: currency(totalPrice.toFixed(2)) });
    // } else {
    //   message.error(msg);
    // }
  }
  requestAddressList = () => {
    send({
      url: '/ipp/user-address/select',
      method: 'GET',
    }).then(res => {
      if (res.data && res.data.code === 0) {
        const { list = [] } = res.data.data;
        let data = [];
        list.forEach((item) => {
          data.push({
            ...item,
            id: item.id,
            userId: item.user_id,
            username: item.username,
            phone: item.phone,
            countryId: item.country_id,
            countryName: item.country_name,
            provinceId: item.province_id,
            provinceName: item.province_name,
            areaId: item.area_id,
            areaName: item.area_name,
            cityId: item.city_id,
            cityName: item.city_name,
            address: item.address,
            postalCode: item.postal_code,
            isDefault: item.is_default,
            createTime: item.create_time,
            updateTime: item.update_time,
          });
        });

        // 默认地址放到第一位
        data.sort((a, b) => {
          return b.isDefault - a.isDefault;
        });
        let others = data.slice(1);
        this.setState({
          addressList: data,
          currentAddress: data[0],
          otherAddressList: others,
        });
      }
    });
  }

  moreBtnClicked = () => {
    this.setState({
      addressIsFold: !this.state.addressIsFold
    });
  }

  selectAddress = (addressId) => {
    let currentAddress = {};
    let otherAddressList = [];
    this.state.addressList.forEach(obj => {
      if (Number(obj.id) === Number(addressId)) {
        currentAddress = obj;
      } else {
        otherAddressList.push(obj);
      }
    });
    this.setState({
      addressIsFold: true,
      currentAddress,
      otherAddressList
    });
  }

  toSubmitOrder = async () => {
    try {
      const { currentAddress, shopList, expected_date } = this.state;
      if (!currentAddress || !currentAddress.id) {
        message.info('请先选择收货地址', 2);
        return;
      }
      if (!expected_date) {
        message.info('请先选择到货时间', 2);
        return;
      }
      if (this.state.submitLock) { return; }
      this.setState({ submitLock: true });
      const { data: { msg, code } } = await enquiryCreateOrder({ order_data: shopList, address_id: currentAddress.id, expected_date, pay_channel: 1 });
      if (+code === 0) {
        this.props.history.push('/basic/submit/1/result');
      } else {
        message.error(msg);
        this.setState({ submitLock: false });
      }
    } finally {
      this.setState({ submitLock: false });
    }
  }

  changeTime = (supplierId) => {
    // let index = this.state.shopList.findIndex(obj => obj.supplier_id === supplierId);
    // if (index !== -1) {
    //   let shopList = this.state.shopList;
    //   shopList[index].arriveTime = dateFormat(new Date(), 'yyyy-MM-dd');
    //   this.setState({
    //     shopList,
    //     currentSupplierId: supplierId,
    //     showDatePicker: true
    //   });
    // }
    this.setState({ showDatePicker: true, expected_date: dateFormat(new Date(), 'yyyy-MM-dd') });
  }

  dateChanged = (moment, date) => {
    this.setState({
      showDatePicker: false,
      expected_date: date
    });
    // const index = this.state.shopList.findIndex(obj => obj.supplier_id === this.state.currentSupplierId);
    // if (index !== -1) {
    //   const shopList = this.state.shopList;
    //   shopList[index].expected_time = date;
    //   this.setState({
    //     shopList
    //   });
    // }
  }

  addNewAddress = () => {
    this.setState({
      addressModalVisible: true,
    });
    this.record = {};
  }

  editAddress = () => {
    this.record = this.state.currentAddress;
    this.setState({
      addressModalVisible: true,
    });
  }

  hideModal = () => {
    this.setState({
      addressModalVisible: false
    });
    this.record = {};
  }
  submitModal = () => {
    this.setState({
      addressModalVisible: false
    });
    this.record = {};
    this.requestAddressList();
  }
  toProductDetail = (product) => {
    const { spu_id, supplier_id, norms_id } = product;
    if (!spu_id || !supplier_id || !norms_id) {
      message.info('商品缺少spu_id或norms_id或supplier_id', 2);
      return;
    }
    this.props.history.push('/basic/product/detail/' + spu_id + '/' + supplier_id + '/' + norms_id);
  }
  render() {
    const { shopList = [], totalCount, addressList, addressIsFold, currentAddress, otherAddressList, showDatePicker, addressModalVisible, loading, submitLock, expected_date } = this.state;
    // const { shopList, totalCount, totalPrice, addressList, addressIsFold, currentAddress, otherAddressList, addressModalVisible, loading, submitLock } = this.state;
    const type = this.type;
    let stepArray = stepConfig[type];
    let columns = type === 'enquiryCart' ? this.columns : this.columnsForPlan;

    let header = (
      <div className="submit-order-top">
        <img style={{ width: 132, height: 60 }} src={cpLogoImg} alt="" />
        <div className="steps">
          <CpSteps current={1} steps={stepArray} />
        </div>
      </div>
    );

    let addressItem = (item) => {
      return (
        (!item || !item.id) ? null : (
          <div>
            <span>{item.username}</span>
            <span style={{ marginLeft: '20px' }}>{item.provinceName + item.cityName + item.areaName + item.address}</span>
            <span style={{ marginLeft: '20px' }}>{item.phone}</span>
            <span style={{ marginLeft: '20px' }}>{item?.warehouse?.warehouse_name}</span>
          </div>
        )
      );
    };

    function disabledDate(current) {
      return current && current < moment().subtract(1, "days"); //当天之前的不可选，不包括当天
    }

    return (
      <div className="submit-order">
        {loading ? <CpLoading size="large" className="cp-loading" /> : null}
        {header}
        <div className="address-info">
          <div className="address-title">收货信息</div>
          <div className="address-list">
            <div className="left">
              {
                addressList.length <= 0 && (
                  <div className="empty-address">
                    <Button className="empty-address-btn" icon={<PlusOutlined />} onClick={this.addNewAddress}>添加地址</Button>
                  </div>
                )
              }
              {
                addressList.length > 0 && (
                  <Fragment>
                    <div className="default-address">
                      <div className="address-item">
                        {addressItem(currentAddress)}
                        <span className='pointer' onClick={this.editAddress}>编辑</span>
                        <img className="cp-selected-icon" src={cpSelected} alt=""></img>
                      </div>
                    </div>
                    {
                      !addressIsFold && (
                        <div className="other-address">
                          {
                            otherAddressList.map((item, index) => {
                              return (
                                <div key={index} className="address-item other" onClick={() => { this.selectAddress(item.id); }}>
                                  {addressItem(item)}
                                </div>
                              );
                            })
                          }
                        </div>
                      )
                    }
                    {
                      addressList.length > 1 && (
                        <Button className="address-more" onClick={this.moreBtnClicked}>
                          {
                            addressIsFold ? '更多地址' : '收起更多地址'
                          }
                          {
                            addressIsFold ? <DownOutlined style={{ marginLeft: '10px' }} /> : <UpOutlined style={{ marginLeft: '10px' }} />
                          }
                        </Button>
                      )
                    }
                  </Fragment>
                )
              }
            </div>
            <span className='pointer' onClick={this.addNewAddress}>新增收货地址</span>
          </div>
        </div>
        <div className="payway-info">
          <div className="payway-title">支付方式</div>
          <div className="payway-list">
            <div className="payway-item">
              线下付款
              <img className="cp-selected-icon" src={cpSelected} alt=""></img>
            </div>
          </div>
        </div>
        <div className="product-info">
          <div className="product-title">送货清单</div>
          <div className="product-list">
            <table className="cp-table">
              <thead>
                <tr>
                  {
                    columns.map((item, index) => {
                      return (
                        <th key={index} style={{ textAlign: item.align }}>
                          {item.name}
                        </th>
                      );
                    })
                  }
                </tr>
              </thead>
              <tbody>
                <tr>
                  <Fragment>
                    <td colSpan={(columns.length)} className="td-group group-item">
                      <span>{this.type === 'enquiryCart' ? '期望到货时间：' : '期望到货时间：'}</span>
                      {
                        expected_date && expected_date.length && (
                          <DatePicker
                            bordered={false}
                            allowClear={false}
                            placeholder=""
                            suffixIcon={false}
                            disabledDate={disabledDate}
                            open={showDatePicker}
                            onChange={this.dateChanged}
                          />
                        )
                      }
                      <span className='pointer' style={{ color: 'blue' }} onClick={() => { this.changeTime(); }}>{expected_date.length ? '修改' : '选择'}</span>
                    </td>
                  </Fragment>
                </tr>
                {
                  shopList.map((item, index) => {
                    return <tr key={index}>
                      {
                        columns.map((col, i) => {
                          if (col.key === 'product') {
                            return (<td key={i} style={{ textAlign: col.align, color: col.color }} className="td-group"><div>{item.sku_name}</div><div>{item.sale_norms}</div></td>);
                          } else if (col.key === 'sale_number') {
                            return (<td key={i} style={{ textAlign: col.align, color: col.color }}><div>{+item.sale_number}</div></td>);
                          }
                          return null;
                        })
                      }
                    </tr>;
                  })
                }
              </tbody>
            </table>
          </div>
        </div>
        <div className="total-info">
          <div>共<span className="total-count">{totalCount}件</span>商品<span hidden={type === 2}>
            {/* ，总价：<span className="total-price">￥{totalPrice}</span> */}
          </span>
          </div>
          <div style={{ color: 'rgba(0,0,0,0.5)' }}>
            {addressItem(currentAddress)}
          </div>
        </div>
        <div className="bottom">
          <Button className={submitLock ? 'submit-button unactive' : 'submit-button'} onClick={this.toSubmitOrder}>提交询价单</Button>
        </div>
        {
          addressModalVisible && (
            <CpAddressModal
              record={this.record}
              hideModal={this.hideModal}
              submitModal={this.submitModal}>
            </CpAddressModal>
          )
        }
      </div>
    );
  }
}
